import { useShare } from "./hooks/useShare";
import ShareInputArea from "./components/ShareInputArea";
import ShareActions from "./components/ShareActions";
import Sharedetail from "../sharedetail/Sharedetail";
import "./share.scss";

const Share = () => {
  const { openModal, setOpenModal, currentUser, handleShareSubmit } = useShare();

  return (
    <div className="share">
      <div className="container">
        <ShareInputArea 
          currentUser={currentUser} 
          onOpenModal={() => setOpenModal(true)} 
        />
        
        <hr />
        
        <ShareActions 
          onOpenModal={() => setOpenModal(true)} 
        />
        
      </div>

      {openModal && (
        <Sharedetail
          setOpenModal={setOpenModal}
          handleShare={handleShareSubmit}
          currentUser={currentUser}
        />
      )}
    </div>
  );
};

export default Share;